import React from 'react';
import HeroSection from './sections/HeroSection';
import PainBridge from './sections/PainBridge';
import TrustLoopSection from './sections/TrustLoopSection';
import ProductsPreview from './sections/ProductsPreview';
import MasterclassTeaser from './sections/MasterclassTeaser';

const HomePage: React.FC = () => {
  return (
    <>
      <HeroSection />
      <PainBridge />
      <TrustLoopSection />
      <ProductsPreview />
      <MasterclassTeaser />
    </>
  );
};

export default HomePage;
